import {Subject, takeUntil} from "rxjs";
import {Injectable, NgZone, OnDestroy} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {AppConstants} from "@shared/util/app-constants";
import {TitleProvider, TitleStringProvider} from "@app/layout/layout.types";
import {TitleProviderService} from "@shared/services/ui/title-provide/title-provider.service";

@Injectable({
  providedIn: 'root'
})
export class TitleProviderObserverService implements OnDestroy {

  private readonly ngUnsubscribe = new Subject<void>();

  private titleProvider: TitleProvider | TitleStringProvider | null;
  private title: string | null;

  constructor(ngZone: NgZone, private titleService: Title, private titleProviderService: TitleProviderService) {
    ngZone.onStable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      const title = this.titleProviderService.getTitle(this.titleProvider);
      if (title !== this.title) {
        this.title = title;
        this.setTitle(this.title);
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public setComponent(component: any): void {
    this.titleProvider = this.titleProviderService.isTitleProvider(component) ? component : null;
    this.title = this.titleProviderService.getTitle(this.titleProvider);
    this.setTitle(this.title);
  }

  private setTitle(title: string | null): void {
    const t = title ? title + ' - ' : '';
    this.titleService.setTitle(t + AppConstants.DEFAULT_TITLE);
  }
}
